import React from 'react'

function ViewUser({ user, closeModal }) {
  if (!user) return null;
  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { date: formattedDate, time: formattedTime };
  }

  const url = 'uploads/'
  const { date, time } = formatDateTime(user?.createdAt);

  const isHomeAddress = user?.addressType === 'Home';
  const isOfficeAddress = user?.addressType === 'Office';
  return (
    <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="manufacturerModal">Details</h5>
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
          <div className="modal-body px-5">
            <div className="d-box mt-3 pt-1">
              <ul className="d-flex list-unstyled justify-content-between">
                <li><span>userType: </span>{user?.deviceType}</li>
                <li><span>Name: </span>{`${user?.firstName || "N/A"} ${user?.lastName || ""}`.trim() || "N/A"}</li>
                <li><span>Mobile No: </span> {user?.mobileNo}</li>
                <li><span>Email: </span> {user?.email}</li>
                <li><span>State: </span> {user.stateName}</li>
                <li><span>City: </span> {user?.cityName}</li>
                <li><span>plan: </span> {user?.subscription?.plan?.planName}</li>
                <li><span>Registration Date: </span> {date}</li>
                <li><span>Building: </span> {user?.bulding}</li>
                <li><span>Apartment: </span> {user?.apartment}</li>
                <li><span>Floor: </span> {user?.floor}</li>
                <li><span>Street :</span>{user?.street}</li>

                <li>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="addressType"
                      id="homeAddress"
                      checked={isHomeAddress}
                    />
                    <label className="form-check-label" htmlFor="homeAddress">
                      Set as current home address
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="addressType"
                      id="officeAddress"
                      checked={isOfficeAddress}
                    />
                    <label className="form-check-label" htmlFor="officeAddress">
                      Set as Office address
                    </label>
                  </div>
                </li>
                <li style={{ marginRight: "320px" }}
                ><span>Address :</span>{user?.address}</li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewUser